import { h } from "@stencil/core";
export function defaultItem({ option, markItemProps, tooltipClass }) {
  return (h("alk-tooltip", { customClass: tooltipClass, class: "alk-tooltip-stretch", position: "cursor-tracking" }, h("alk-mark-item", Object.assign({}, markItemProps, { key: option.id, label: option.name }), h("ion-icon", { src: "assets/icon/md/fnx_md-mark.svg" })), h("p", { slot: "tooltip", innerHTML: option.name })));
}
//# sourceMappingURL=default-item.js.map
